import { useCallback } from 'react';

import { handleSubmitFeedback } from 'businessLogic/Feedback';
import { SplunkReporter } from 'reporting/splunk/SplunkReporter';
import { AI_ASSIST_FORUM_IDS } from 'types/constants';

const splunkReporter = SplunkReporter.getInstance();

interface ChatMessagesParams {
  messages: any[];
  sale: any;
  payment: any;
  portal: string;
  env: string;
  wallet: any;
  realmId: string;
  ssrtid: string;
  authToken: string;
  insight: any;
  activityObject: string;
  logger: string;
}

export const useAiAssistChatMessages = () => {
  const submitChatMessages = useCallback(async (params: ChatMessagesParams) => {
    const {
      messages,
      sale,
      payment,
      portal,
      env,
      wallet,
      realmId,
      ssrtid,
      authToken,
      insight,
      activityObject,
      logger,
    } = params;

    try {
      const chatMessagesData = {
        '[chat]': '',
        feature: 'ai_assist_chat',
        message: messages,
        autoPayEligible: sale?.scheduleInfo?.autoPayEligible ?? false,
        isAutoPayOn: payment?.isAutoPayOn ?? false,
      };
      const dataToSend = JSON.stringify(chatMessagesData);

      await handleSubmitFeedback(
        {
          feedback: dataToSend,
          payingExperience: null,
          userVoice: false,
          customForumId:
            env !== 'prod'
              ? AI_ASSIST_FORUM_IDS.AI_ASSIST_CHAT_NON_PROD
              : AI_ASSIST_FORUM_IDS.AI_ASSIST_CHAT_PROD,
        },
        {
          portal,
          wallet,
          realmId,
          ssrtid,
          authToken,
          sale,
          insight,
          guestCheckoutEmail: '',
        }
      );
    } catch (error) {
      splunkReporter.contextual({
        logInfo: { logLevel: 'error', logger },
        event: 'feedbackLink',
        action: 'submit',
        activityInfo: {
          activityObject,
          message: error instanceof Error ? error.message : String(error),
        },
      });
    }
  }, []);

  return { submitChatMessages };
};
